import type { Action, Dispatch } from 'core/use-cases/utilities';
import { PERSIST } from 'core/use-cases/utilities';
import config from 'config';

export const clearDataPersist = () => (next: Dispatch) => (action: Action) => {
  if (action.type === PERSIST) {
    localStorage.removeItem(`persist:${config.app.short}-stargate`);
  }

  return next(action);
};
